import { Helmet } from "react-helmet-async";

const SITE_URL = "https://themelbournepainters.com.au";
const DEFAULT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/f356e486-2013-43a6-a960-a50c27505bc4/images/29383ace10214344ab9dbf2c4cf77c8c3d92666c7230385a3c21e76adff9e659.png";

/**
 * Per-page SEO meta + structured data.
 *
 * @param {{
 *   title: string,
 *   description: string,
 *   path?: string,      // e.g., "/painters/mornington" — for canonical + og:url
 *   image?: string,
 *   keywords?: string,
 *   jsonLd?: object,    // optional schema.org payload merged with site default
 *   noindex?: boolean,  // set true for admin / 404
 * }} props
 */
export default function Seo({ title, description, path = "/", image, keywords, jsonLd, noindex = false }) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="The Melbourne Painters" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_AU" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")}
        </script>
      )}
    </Helmet>
  );
}
